<form class="inline-flex">
    <div class="form-group">
        <label *ngIf="!disableTitle" for="lang-selector">{{ "shared.i18n.languageSelector.chooseLanguage" | translate }}</label>
        <select name="lang-selector" class="form-control" [(ngModel)]="selectLang" (change)="setTransLanguage()">
        <option value="es">{{ "shared.i18n.languageSelector.language.spanish" | translate }}</option>
        <option value="en">{{ "shared.i18n.languageSelector.language.english" | translate }}</option>
      </select>
    </div>
</form>